export const CircuitoTomoData = [
  {
    pregunta: "¿Tiene un peso superior a los 140kg?",
    name: "pesoSuperior",
    valor: null,
    visible: true,
    key: 0
  },
  {
    pregunta: "¿Tiene un peso superior a los 180kg?",
    name: "pesoSuperiorCritico",
    valor: null,
    visible: false,
    key: 1
  },
  {
    pregunta: `¿La orden médica indica con Contraste?`,
    name: "conContraste",
    valor: null,
    visible: true,
    key: 2
  },
  {
    pregunta: `¿Tiene insuficiencia renal?`,
    name: "insRenal",
    valor: null,
    visible: false,
    key: 3
  },
  {
    pregunta: `¿Usted es diabético o hipertenso?`,
    name: "diabeticoHipertenso",
    valor: null,
    visible: false,
    key: 4
  },
  {
    pregunta: `¿Se realizó en las últimas 72hs. algún otro estudio con contraste (resonancia, cámara gamma, etc)?`,
    name: "contrasteReciente",
    valor: null,
    visible: false,
    key: 5
  },  
  {
    pregunta: `¿Usted está embarazada o tiene la sospecha de estarlo?`,
    name: "embarazada",
    valor: null,
    visible: false,
    key: 6
  },
  {
    pregunta: `¿Usted está amamantando?`,
    name: "amamantando",
    valor: null,
    visible: false,
    key: 7
  }
];
